import { useMemo } from 'react'
import { isAdmin } from '../../../../../services/AccountService'

export const useNewBodyCheckbox = (
  element: any,
  data: any,
  checkboxStore: any,
) => {
  const {
    toggleSelectId,
    allIds,
    selectedIds,
    status,
    updateSelectedIds,
    isForbiddenPaymentType,
    setIsForbiddenPaymentType,
    setForbiddenPaymentCount,
  } = checkboxStore

  const handleClickCheckbox = (e: any) => {
    e.stopPropagation()

    if (!status) {
      const newIds = data.content
        .filter((el: any) => el.status === element.status)
        .map((el: any) => el.id)
      updateSelectedIds(newIds, selectedIds)
    }

    if ([1, 2, 3, 5].includes(element.financialSourceId)) {
      const wasSelected = selectedIds.includes(element.id)
      if (!isForbiddenPaymentType && !wasSelected) {
        setIsForbiddenPaymentType(true)
      } else {
        if (wasSelected) {
          setForbiddenPaymentCount('decrement')
        } else {
          setForbiddenPaymentCount('increment')
        }
      }
    }

    const shouldReset =
      selectedIds.length === 1 && selectedIds.includes(element.id)
    if (shouldReset) {
      const newIds = data.content
        .filter((el: any) => (isAdmin() ? [1, 2, 4].includes(el.status) : true))
        .map((el: any) => el.id)
      updateSelectedIds(newIds, selectedIds)
    }

    toggleSelectId(element.id, element.status)
  }

  const checked = selectedIds.includes(element.id)
  const showCheckbox = allIds.includes(element.id)

  return useMemo(
    () => ({ handleClickCheckbox, checked, showCheckbox }),
    [checked, showCheckbox, status, selectedIds.length],
  )
}
